module.exports = __webpack_public_path__ + "static/media/Emisiones.6240941a.png";